import { render, staticRenderFns } from "./WalletRechargeModal.vue?vue&type=template&id=0ce5bd2c"
import script from "./WalletRechargeModal.vue?vue&type=script&lang=js"
export * from "./WalletRechargeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports